function n(e) {
  return [e("x"), e("y")];
}
export {
  n as eachAxis
};
